module.exports = __webpack_public_path__ + "img/usdc.d78b5bc.de24f04a.svg";